import { Helmet } from 'react-helmet'
import Background from './components/background'
import Container from './components/container'
import FormErrors from './components/form-errors'
import Form from './components/password-change-form'

const PasswordChange = () => (
    <Container>
        <Helmet>
            <title>Change Password | GIPHY</title>
        </Helmet>
        <Form />
        <Background />
        <FormErrors />
    </Container>
)

export default PasswordChange
